<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_9409_32391)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.8579 10.2139C11.2232 9.66901 9.67043 11.2219 10.2137 12.855L16.119 30.5699C16.7157 32.3618 19.1945 32.5056 19.9952 30.7939L23.4301 23.4291L30.7946 19.9941C32.5062 19.1951 32.3625 16.7145 30.5706 16.1178L12.8579 10.2139Z"
        fill="url(#paint0_linear_9409_32391)"
      />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.3719 1.67154C13.3719 1.22822 13.1958 0.803056 12.8823 0.489582C12.5688 0.176108 12.1437 0 11.7004 0C11.2571 0 10.8319 0.176108 10.5185 0.489582C10.205 0.803056 10.0289 1.22822 10.0289 1.67154V5.01461C10.0289 5.45793 10.205 5.88309 10.5185 6.19657C10.8319 6.51004 11.2571 6.68615 11.7004 6.68615C12.1437 6.68615 12.5688 6.51004 12.8823 6.19657C13.1958 5.88309 13.3719 5.45793 13.3719 5.01461V1.67154ZM5.79002 3.42665C5.63583 3.267 5.45139 3.13966 5.24746 3.05206C5.04353 2.96446 4.8242 2.91834 4.60226 2.91642C4.38032 2.91449 4.16022 2.95678 3.9548 3.04083C3.74939 3.12487 3.56276 3.24899 3.40582 3.40593C3.24888 3.56288 3.12477 3.74951 3.04072 3.95494C2.95668 4.16036 2.91439 4.38047 2.91632 4.60241C2.91825 4.82436 2.96436 5.0437 3.05196 5.24763C3.13956 5.45157 3.2669 5.63601 3.42654 5.79021L5.79002 8.15711C5.94542 8.31252 6.12992 8.4358 6.33297 8.51991C6.53602 8.60401 6.75365 8.64731 6.97342 8.64731C7.1932 8.64731 7.41083 8.60401 7.61388 8.51991C7.81693 8.4358 8.00143 8.31252 8.15684 8.15711C8.31224 8.00169 8.43552 7.81719 8.51962 7.61413C8.60373 7.41108 8.64702 7.19344 8.64702 6.97366C8.64702 6.75387 8.60373 6.53623 8.51962 6.33318C8.43552 6.13012 8.31224 5.94562 8.15684 5.79021L5.79002 3.42665ZM19.9742 3.42665C20.2876 3.74011 20.4636 4.1652 20.4636 4.60843C20.4636 5.05166 20.2876 5.47675 19.9742 5.79021L17.6107 8.15711C17.4554 8.31241 17.2711 8.4356 17.0682 8.51965C16.8653 8.6037 16.6478 8.64696 16.4282 8.64696C16.2085 8.64696 15.9911 8.6037 15.7882 8.51965C15.5853 8.4356 15.4009 8.31241 15.2456 8.15711C15.0903 8.0018 14.9671 7.81743 14.8831 7.61452C14.799 7.4116 14.7558 7.19412 14.7558 6.97449C14.7558 6.75486 14.799 6.53738 14.8831 6.33447C14.9671 6.13155 15.0903 5.94718 15.2456 5.79188L17.6107 3.42832C17.9242 3.11496 18.3493 2.93892 18.7925 2.93892C19.2357 2.93892 19.6608 3.11329 19.9742 3.42665ZM0 11.7008C0 11.2574 0.176102 10.8323 0.489566 10.5188C0.80303 10.2053 1.22818 10.0292 1.67148 10.0292H5.01445C5.45775 10.0292 5.8829 10.2053 6.19636 10.5188C6.50983 10.8323 6.68593 11.2574 6.68593 11.7008C6.68593 12.1441 6.50983 12.5692 6.19636 12.8827C5.8829 13.1962 5.45775 13.3723 5.01445 13.3723H1.67148C1.22818 13.3723 0.80303 13.1962 0.489566 12.8827C0.176102 12.5692 0 12.1441 0 11.7008ZM8.15516 17.6113C8.31046 17.456 8.43365 17.2716 8.5177 17.0687C8.60174 16.8658 8.645 16.6483 8.645 16.4287C8.645 16.2091 8.60174 15.9916 8.5177 15.7887C8.43365 15.5858 8.31046 15.4014 8.15516 15.2461C7.99987 15.0908 7.8155 14.9676 7.61259 14.8836C7.40969 14.7995 7.19221 14.7562 6.97259 14.7562C6.75297 14.7562 6.53549 14.7995 6.33259 14.8836C6.12968 14.9676 5.94531 15.0908 5.79002 15.2461L3.42654 17.6113C3.2669 17.7655 3.13956 17.95 3.05196 18.1539C2.96436 18.3578 2.91825 18.5772 2.91632 18.7991C2.91439 19.0211 2.95668 19.2412 3.04072 19.4466C3.12477 19.652 3.24888 19.8386 3.40582 19.9956C3.56276 20.1525 3.74939 20.2767 3.9548 20.3607C4.16022 20.4448 4.38032 20.487 4.60226 20.4851C4.8242 20.4832 5.04353 20.4371 5.24746 20.3495C5.45139 20.2619 5.63583 20.1345 5.79002 19.9749L8.15516 17.6113Z"
      fill="url(#paint1_linear_9409_32391)"
    />
    <defs>
      <filter
        id="filter0_i_9409_32391"
        x="10.1032"
        y="8.56076"
        width="22.2823"
        height="23.4386"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset
          dx="0.385529"
          dy="-1.92765"
        />
        <feGaussianBlur stdDeviation="0.771059" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_9409_32391"
        />
      </filter>
      <linearGradient
        id="paint0_linear_9409_32391"
        x1="24.5589"
        y1="24.0266"
        x2="10.5945"
        y2="11.061"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop
          offset="0.793283"
          stop-color="#767676"
          stop-opacity="0.72"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_9409_32391"
        x1="0"
        y1="0"
        x2="12.7878"
        y2="12.2183"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7F56D9" />
        <stop
          offset="1"
          stop-color="#B48FFF"
          stop-opacity="0.77"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
